import React, { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'

export const ResetPasswordPage = () => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    // Sprawdź czy użytkownik przyszedł z linku resetowania hasła
    const checkResetToken = async () => {
      try {
        // Sprawdź czy w URL są parametry resetowania hasła
        const hashParams = new URLSearchParams(window.location.hash.substring(1))
        const accessToken = hashParams.get('access_token')
        const refreshToken = hashParams.get('refresh_token')
        const type = hashParams.get('type')

        console.log('🔍 URL parameters:', { accessToken: accessToken ? 'found' : 'missing', type })

        if (type === 'recovery' && accessToken && refreshToken) {
          // Ustaw sesję używając tokenów z URL
          const { data, error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken
          })

          if (error) {
            console.error('❌ Error setting session:', error)
            setError('Link resetowania hasła jest nieprawidłowy lub wygasł')
            return
          }

          console.log('✅ Session set successfully:', data.user?.email)
        } else {
          // Sprawdź czy jest aktywna sesja
          const { data: { session }, error } = await supabase.auth.getSession()
          console.log('🔍 Current session check:', { session: session ? 'exists' : 'missing', error })

          if (!session) {
            setError('Brak prawidłowego linku resetowania hasła. Sprawdź swój email lub poproś o nowy link.')
          }
        }
      } catch (error) {
        console.error('❌ Reset token check error:', error)
        setError('Wystąpił błąd podczas sprawdzania linku resetowania hasła')
      }
    }

    checkResetToken()
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (password !== confirmPassword) {
      setError('Hasła nie są identyczne')
      return
    }

    if (password.length < 6) {
      setError('Hasło musi mieć co najmniej 6 znaków')
      return
    }

    // Sprawdź czy mamy aktywną sesję przed próbą zmiany hasła
    const { data: { session } } = await supabase.auth.getSession()
    if (!session) {
      setError('Sesja wygasła. Sprawdź swój email i kliknij link resetowania hasła ponownie.')
      return
    }

    setLoading(true)
    setError('')

    try {
      console.log('🔍 Updating password for user:', session.user?.email)
      const { error } = await supabase.auth.updateUser({
        password: password
      })

      if (error) {
        throw new Error(error.message)
      }

      console.log('✅ Password updated successfully')
      setSuccess(true)
    } catch (err: any) {
      console.error('❌ Password update error:', err)

      if (err.message?.includes('session')) {
        setError('Sesja wygasła. Sprawdź swój email i kliknij link resetowania hasła ponownie.')
      } else {
        setError(err.message || 'Błąd podczas zmiany hasła')
      }
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '2rem' }}>
            <img
              src="/assets/logo.svg"
              alt="TwoPoint"
              style={{ height: '32px' }}
            />
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#4CAF50', marginBottom: '1rem' }}>✅ Hasło zmienione!</h2>
            <p style={{ color: '#666', margin: 0 }}>
              Twoje hasło zostało pomyślnie zmienione.<br />
              Możesz teraz zalogować się używając nowego hasła.
            </p>
          </div>

          <button
            onClick={() => window.location.href = '/'}
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#000000',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            Przejdź do logowania
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img
            src="/assets/logo.svg"
            alt="TwoPoint"
            style={{ height: '32px' }}
          />
        </div>

        <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>
          Ustaw nowe hasło
        </h2>

        <p style={{ textAlign: 'center', color: '#666', marginBottom: '2rem' }}>
          Podaj nowe hasło dla swojego konta
        </p>

        {error && (
          <div style={{
            backgroundColor: '#ffebee',
            color: '#c62828',
            padding: '0.75rem',
            borderRadius: '4px',
            marginBottom: '1rem',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Nowe hasło:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              minLength={6}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Potwierdź hasło:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: loading ? '#ccc' : '#000000',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Aktualizowanie...' : 'Zmień hasło'}
          </button>
        </form>
      </div>
    </div>
  )
}